<template>
  <div class="mt-0 d-flex flex-column flex" style="height: 100%">
    <v-row justify="center" v-if="getUser != null"  style="height: 100%">
      <v-col cols="12" sm="12"  style="height: 100%">
        <x-card :home="true" width="100%" class="mt-2" elevation="0" outlined  style="height: 100%; padding-left: 3em; padding-right: 3em;">
          <v-card-text class=""  style="height: 100%">
            <div class="mb-2">
              <div class="primaryLight rounded-lg px-8">
                <div class="d-flex justify-space-between py-1 mx-2">
                  <div class="white--text" v-if="$vuetify.breakpoint.mdAndUp">{{ (step * quotient).toFixed(0) + '% - Start' }}</div>
                  <div class="white--text ">
                    {{
                      /* !getUser != null ? getUser.admission.applicationType.name : "" */
                      title && title.toUpperCase()
                    }}
                  </div>
                  <div class="white--text" v-if="$vuetify.breakpoint.mdAndUp">100% - Stop</div>
                </div>
              </div>

              <!--<div class="text-center mt-4 font-weight-bold" style="color: #000000 !important;">{{}}</div>-->
            </div>
            <div style="background-color: #F1F1F1" class="rounded-lg pa-4 pt-8 mb-8 mt-4">
              <personal-details :no-header="true" @update-title="v => title = v" v-on:success="increment" v-if="step === 1"></personal-details>
              <contact-details :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 2"></contact-details>
              <next-of-kin-details :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 3"></next-of-kin-details>
              <nysc-details :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 4"></nysc-details>
              <qualifications :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 5"></qualifications>
              <programme-and-passport :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 6">
              </programme-and-passport>
              <application-fee :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 7"></application-fee>
              <screening-fee :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 8"></screening-fee>
              <u-t-m-e-details :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 9"></u-t-m-e-details>
              <s-s-c-e-details :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 10"></s-s-c-e-details>
              <scratch-card-manual :no-header="true" @update-title="v => title = v" v-on:success="increment" v-on:back="decrement" v-if="step === 11"></scratch-card-manual>
              <application-complete :no-header="true" @update-title="v => title = v" v-if="step === 12"></application-complete>
            </div>
          </v-card-text>
        </x-card>
      </v-col>
    </v-row>
    <div class="d-flex flex-column" style="height: 100%" v-else>
      <div class="mx-auto my-auto">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </div>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType"
      v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>

<script>
import PersonalDetails from "../../pages/lafia/components/PersonalDetails";
import ContactDetails from "../../pages/lafia/components/ContactDetails";
import NextOfKinDetails from "../../pages/lafia/components/NextOfKinDetails";
import UTMEDetails from "../../pages/lafia/components/UTMEDetails";
import SSCEDetails from "../../pages/lafia/components/SSCEDetails";
import Qualifications from "../../pages/lafia/components/Qualifications";
import NyscDetails from "../../pages/lafia/components/NyscDetails";
import ProgrammeAndPassport from "../../pages/lafia/components/ProgrammeAndPassport";
import { mapActions, mapGetters } from "vuex";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import ApplicationFee from "../../pages/lafia/components/ApplicationFee";
import ScreeningFee from "../../pages/lafia/components/ScreeningFee";
import LoginUtil from "@/login/LoginUtil";
import ApplicationComplete from "../../pages/lafia/components/ApplicationComplete";
import StudentStatus from "@/shared/StudentStatus";
import ScratchCard from "../../pages/lafia/components/ScratchCard";
import ScratchCardManual from "../../pages/lafia/components/ScratchCardManual";
import XCard from "@ui/components/XCard.vue";



export default {
  name: "Application",
  components: {
    XCard,
    ScratchCardManual,
    ScratchCard,
    ApplicationComplete,
    ProgrammeAndPassport,
    ScreeningFee,
    ApplicationFee,
    MessageBox,
    LoadingDialog,
    SSCEDetails,
    UTMEDetails,
    NextOfKinDetails,
    ContactDetails,
    PersonalDetails,
    Qualifications,
    // eslint-disable-next-line vue/no-unused-components
    NyscDetails,
  },


  data: () => ({
    step: 0,
    finalStep: 12,
    quotient: 100 / 12,
    steps: [],
    messageShow: false,
    canIncrement: true,
    loading: false,
    message: "",
    messageType: "",
    title: '',
    stepsLength: -2, // set to negative 2 to avoid calling computeSteps() on every user update
  }),

  methods: {
    increment: function () {
      this.step = this.steps[++this.stepsLength];
    },

    decrement: function () {
      this.step = this.steps[--this.stepsLength];
    },

    hasStep(st) {
      for (let v = 0; v < this.steps.length; v++) {
        if (this.steps[v] === st)
          return true
      }

      return false
    },

    requireQualification(){
      if (this.getUser != null) {
        let ap = this.getUser.admission.applicationType
        return ap.qualificationDetailsEnabled && (this.getUser.modeOfEntry == null || this.getUser.modeOfEntry.requireScreeningDocuments)
      }

      return false;
    },

    computeSteps() {
      if (this.getUser != null) {
        let ap = this.getUser.admission.applicationType
        // compute and keep track of steps
        // first step is personal details
        this.steps = []
        this.steps.push(1)
        this.stepsLength = 0
        // reset
        this.canIncrement = true
        // if first step is complete
        if (this.getInformation != null && this.getInformation.lga != null) {
          this.stepsLength++
        } else{
          this.canIncrement = false
        }
        // if contact details enabled
        if (ap.contactDetailsEnabled) {
          this.steps.push(2)
          // contact
          if (this.getInformation != null && this.getInformation.contactLga != null && this.canIncrement) {
            this.stepsLength++
          }else{
            this.canIncrement = false
          }
        }

        // if next of kin details enabled
        if (ap.nextOfKinDetailsEnabled) {
          this.steps.push(3)
          // next of kin
          if (this.getInformation != null && this.getInformation.nextOfKinPhone != null && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // if NYSC details enabled
        if (ap.nyscDetailsEnabled) {
          this.steps.push(4)
          // nysc
          if (this.getNYSCDetails != null && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // if Qualifications details enabled
        if (ap.qualificationDetailsEnabled && (this.getUser.modeOfEntry == null || this.getUser.modeOfEntry.requireScreeningDocuments)) {
          this.steps.push(5)

          if (this.getQualificationCertificate.length > 0 && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // programme selection step
        this.steps.push(6)
        // user has
        if (this.getUser.programme != null && this.canIncrement) {
          this.stepsLength++
        } else{
          this.canIncrement = false
        }

        // if application fee enabled
        if (ap.applicationFee > 0.1) {
          this.steps.push(7)
          //application complete
          if (StudentStatus[this.getUser.studentStatus].value >= StudentStatus.APPLICATION_COMPLETE.value && this.canIncrement) {
            this.stepsLength++
            // else the user will remain in application fee payment screen
          } else{
            this.canIncrement = false
          }
        }

        // if screening enabled
        if (ap.screeningFee > 0.1) {
          this.steps.push(8)
          //screening complete
          if (StudentStatus[this.getUser.studentStatus].value > StudentStatus.SCREENING_PAYMENT_PENDING.value && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // if UTME details enabled
        if (ap.utmeDetailsEnabled && (this.getUser.modeOfEntry == null || this.getUser.modeOfEntry.requireUtmeScores)) {
          this.steps.push(9)
          if (this.getUTMEDetails != null && StudentStatus[this.getUser.studentStatus].value > StudentStatus.SCREENING_PAYMENT_PENDING.value && this.canIncrement) {
            this.stepsLength++
          } else{
            this.canIncrement = false
          }
        }

        // if SSCE details enabled
        if (ap.ssceDetailsEnabled) {
          this.steps.push(10)
          if (this.getSSCEDetails.length > 0) {
            // check if scratch card is required
            if (ap.scratchCardDetailsEnabled) {
              this.steps.push(11)
              // if scratch card has been purchased
              if(this.getScratchCards.length === this.getSSCEDetails.length && this.canIncrement){
                this.stepsLength = this.stepsLength + 2
              } else{
                if(this.canIncrement)
                  this.stepsLength++
                else
                  this.canIncrement = false
              }
            } else{
              if(this.canIncrement)
                this.stepsLength = this.stepsLength + 2
              else
                this.canIncrement = false
            }
          }
        }

        // incase scratch card was not included
        if(ap.scratchCardDetailsEnabled && !this.steps.includes(11, 0)){
          this.steps.push(11)
          if(this.getSSCEDetails.length > 0 && this.getScratchCards.length === this.getSSCEDetails.length && this.canIncrement){
            this.stepsLength = this.stepsLength + 2
          }
        }

        // push application complete
        this.steps.push(this.finalStep)

        // assign step
        this.step = this.steps[this.stepsLength];
      }
    },

    ...mapActions(["getInitialData"]),
  },

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown;
    },

    ...mapGetters(["getUser", 'getInformation', 'getNYSCDetails', 'getQualificationCertificate', 'getUTMEDetails', 'getSSCEDetails', "getScratchCards"]),
  },

  watch: {
    getUser: function (val) {
      if (val) {
        // compute steps
        if (this.stepsLength < 0) {
          this.computeSteps()
          if (StudentStatus[this.getUser.studentStatus].value >= StudentStatus.SCREENING_PENDING.value) {
            if((this.requireQualification() && this.getQualificationCertificate != null && this.getQualificationCertificate.length > 0) ||
                !this.requireQualification()){
              this.step = this.finalStep;
              return;
            }
          }
          this.step = this.steps[this.stepsLength]
        }
      }
    },

    // step: function (val) {
    //   this.stepsLength = this.steps.indexOf(val)
    // }
  },

  created() {
    if (window.canReload) {
      window.canReload = false;
      window.location.reload();
      return;
    }
    if (!LoginUtil.checkAuth()) {
      // not logged in
      this.$router.push("/");
    }
    if (this.getUser != null) {
      if (StudentStatus[this.getUser.studentStatus].value >= StudentStatus.SCREENING_PENDING.value) {
        if((this.requireQualification() && this.getQualificationCertificate != null && this.getQualificationCertificate.length > 0) ||
            !this.requireQualification()){
          this.step = this.finalStep;
          return;
        }
      }
    }

    this.computeSteps()
  },
};
</script>

<style>
.v-text-field >>> .v-input__slot::before  { border-color: #ECBD44 !important; }
</style>
